var map = {
	"./common.json": 197,
	"./conversation.json": 82503,
	"./layout.json": 57730,
	"./resultPage.json": 95918,
	"locales/zh/common.json": 197,
	"locales/zh/conversation.json": 82503,
	"locales/zh/layout.json": 57730,
	"locales/zh/resultPage.json": 95918
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38433;